module.exports = __webpack_public_path__ + "img/about/80243-025.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-025.png
// module id = 29
// module chunks = 0